import M$plugin$Wmc from './/facade/js/wmc';
import M$control$WmcControl from './/facade/js/wmccontrol';
import M$impl$control$WmcControl from './/impl/ol/js/wmccontrol';
import M$impl$control$WmcLayer from './/impl/ol/js/wmclayer';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.Wmc = M$plugin$Wmc;
window.M.control.WmcControl = M$control$WmcControl;
window.M.impl.control.WmcControl = M$impl$control$WmcControl;
window.M.impl.control.WmcLayer = M$impl$control$WmcLayer;
